export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10.5" fill="#D9D9D9" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.959 7.71183C15.3052 7.42923 15.8051 7.42955 16.1514 7.71183L16.2237 7.77629L16.2881 7.84855C16.5906 8.21946 16.5693 8.76647 16.2237 9.11222L13.336 11.9999L16.2237 14.8876C16.5924 15.2565 16.5925 15.8548 16.2237 16.2236C15.8549 16.5921 15.2565 16.5922 14.8877 16.2236L12.0001 13.3359L9.11235 16.2236C8.7435 16.5921 8.14514 16.5923 7.77642 16.2236C7.40779 15.8548 7.40793 15.2564 7.77642 14.8876L10.6641 11.9999L7.77642 9.11222C7.40786 8.74344 7.40786 8.14506 7.77642 7.77629L7.84868 7.71183C8.19497 7.42948 8.69487 7.4293 9.04107 7.71183L9.11235 7.77629L12.0001 10.664L14.8877 7.77629L14.959 7.71183Z"
      fill="#656787"
    />
  </svg>
);
